import ActionStepRow from "./ActionStepRow";

const SEND_STEP_TYPE = "payment.request.send";

// The vertical, dotted-line list of grouped steps shown under an Action card's header,
// collapsible via a CSS grid-row trick (height:auto can't transition directly). `instant`
// suppresses the transition for the initial programmatic snap-open.
export default function ActionStepTimeline({ groups, expanded, instant, onPreviewStep }) {
  if (!groups.length) return null;

  // Number the send rows (each an instalment) so a preview can title itself "Instalment N of M".
  const sendTotal = groups.filter((g) => g.stepType === SEND_STEP_TYPE).length;
  let sendSeen = 0;

  return (
    <div
      className={instant ? "grid" : "grid transition-[grid-template-rows] duration-200 ease-out"}
      style={{ gridTemplateRows: expanded ? "1fr" : "0fr" }}
    >
      <div className="overflow-hidden">
        {/* Bottom padding clears the card's absolutely-positioned expand/collapse toggle. */}
        <div className="border-t border-zinc-100 pb-6 pt-3">
          {groups.map((group, i) => {
            const instalment =
              group.stepType === SEND_STEP_TYPE
                ? { number: (sendSeen += 1), total: sendTotal }
                : null;
            return (
              <ActionStepRow
                key={group.steps[0]?.stepId ?? `${group.stepType}-${i}`}
                group={group}
                isLast={i === groups.length - 1}
                onPreviewStep={onPreviewStep}
                instalment={instalment}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
